
export function setLoader(value) {
    return {
        type: 'IS_LOADING',
        value
    }
}

export function setLoaderMessagequeue(value) {
    return {
        type: 'IS_LOADING_MESSAGEQUEUE',
        value
    }
}

export function setLoaderExport(value) {
    return {
        type: 'IS_LOADING_EXPORT',
        value
    }
}


// WEBPACK FOOTER //
// ./src/actions/loader.js